import * as types from '../constants/officeRunnerConstants'

const address = (state = null, action) => {
  switch (action.type) {
    case types.GEOCODE_SUCCESS:
      return action.result
    default:
      return state
  }
}

export default address



// WEBPACK FOOTER //
// ./src/reducers/addressReducer.js